// extracted by mini-css-extract-plugin
export default {"root":"Testimonial_root__qs7fJ","customSwiper":"Testimonial_customSwiper__OaHB1"};